import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store/store';
import App from './App';
// Create browser history to use in the Redux store
import history from './history';
import { LicenseInfo } from '@mui/x-license-pro';
// Get the application-wide store instance, prepopulating with state from the server where available.
//const store = configureStore(history);
/*
ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App history={history}/>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));
    */
//registerServiceWorker();
//LicenseInfo.setLicenseKey('baea3cd9a4bef92313bfbb8b5df7aac9Tz04NTU0NCxFPTE3NDA5MjU5NTgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='); expired
//LicenseInfo.setLicenseKey('3637cd48322b7e2b9ce9e25398c42f9dTz0xMDczNTcsRT0xNzcyNDk1OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI='); // expired
LicenseInfo.setLicenseKey('7d1443bfcccc61059b311f2aee0d5e8bTz0xMjY5MDAsRT0xODA1NDYyNDIzMjI1LFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='); // 3/19/2026
const container = document.getElementById('root') as Element;
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<Provider store={store} >
    <BrowserRouter >
        <App history={history} />
    </BrowserRouter>
</Provider>);